export const TASK_ENGINE_REQUEST_TYPE = 'TASK_ENGINE';
export const TASK_ENGINE_SENTRY_CATEGORY = 'TASK_ENGINE';
